export const style = {
  image: {
    maxWidth: `100%`
  },
  p: {
    fontSize: `14px`,
    lineHeight: `22px`,
    margin: `0 0 20px`,
    color: `#666`
  },
  title: {
    fontSize: `24px`,
    lineHeight: `24px`,
    fontWeight: 300,
    margin: `0 0 10px 0`
  },
  infoBox: {
    marginBottom: `10px`
  },
  infoLabel: {
    fontSize: `14px`,
    fontWeight: 600,
    marginRight: `5px`,
    color: `#666`
  },
  infoValue: {
    fontSize: `14px`,
    fontWeight: 400,
    color: `#666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Games/style/gamebox.js